import React, { useEffect, useState } from 'react';

import googleOneTapClasses from './googleOneTapConnect.module.css';

const defaultProps = {
  showDisplayOr: true,
};

const GoogleOneTap = (props) => {
  const style = {
    position: 'relative',
    top: '0',
    right: '0',
    margin: 'auto',
    zIndex: 999999,
    display: 'block',
  };
  const [displayOr, setDisplayOr] = useState(false);

  useEffect(() => {
    // Add the Google One Tap script to the current context
    const oneTapScript = window.document.createElement('script');
    oneTapScript.setAttribute('type', 'text/javascript');
    oneTapScript.setAttribute('src', 'https://accounts.google.com/gsi/client');
    window.document.body.appendChild(oneTapScript);

    // Once the script has loaded we can begin the configuration process
    // for Google One Tap. If we try to do this immediately, we will encounter
    // a race condition where the script loads after we have attempted to
    // initialize One Tap.
    oneTapScript.onload = () => {
      const googleOneTapOptions = {
        callback: props.onGoogleOneTap,
        cancel_on_tap_outside: false,
        client_id: props.googleClientId,
        prompt_parent_id: 'googleOneTapContainer',
      };

      // FRON-14332 wait 10 seconds before showing google oneTap popup
      const timeout = setTimeout(() => {
        // Initialize Google One Tap with the provided configuration
        window.google.accounts.id.initialize(googleOneTapOptions);

        // This will attempt to render the Google One Tap dialog. `onNotification`
        // will receive notifications that indicate the status of Google One Tap.
        window.google.accounts.id.prompt((notification) => {
          setDisplayOr(notification.h);
        });
      }, 10000);

      return () => {
        clearTimeout(timeout);
      };
    };

    return () => {
      // Clean up the remains of Google One Tap when the component is unmounted
      if (window.google) {
        window.google.accounts.id.cancel();
      }
    };
  }, []);

  return (
    <>
      <div style={props.style || style} id="googleOneTapContainer" />
      {displayOr && props.showDisplayOr && (
        <div id="or" className={`container ${googleOneTapClasses.googleOr}`}>
          or
        </div>
      )}
    </>
  );
};

GoogleOneTap.defaultProps = defaultProps;

export default GoogleOneTap;
